import { useKeyPress } from '@innovamat/hooks';
import useResourceNavigation from './use-resource-navigation';

export default function useControls({
  preventArrowKeysEvents,
}: {
  preventArrowKeysEvents?: boolean;
}) {
  const { handleNext, handlePrev } = useResourceNavigation();

  useKeyPress(
    {
      ArrowRight: handleNext,
      ArrowLeft: handlePrev,
    },
    preventArrowKeysEvents
  );
}
